import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import _ from "lodash";
import socket from "../../../../context/socket";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import api from "../../../../utils/api";

const InvestmentAmountData = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [investmentAmountInputData, setInvestmentAmountInputData] = useState({
    amount: "",
  });

  // Extract the card by ID and set initial data
  useEffect(() => {
    if (planYourGoals && card_id) {
      const card = planYourGoals.find((item) => item._id === card_id);
      setSelectedCard(card);

      // If action_data exists, populate input data
      if (card?.action_data?.[0]) {
        const { amount } = card.action_data[0];
        setInvestmentAmountInputData({
          amount,
        });
      }
    }
  }, [planYourGoals, card_id]);

  // Function to save data via API
  const saveData = async (updatedData) => {
    // Check if the "amount" field is filled (or add other required fields if needed)
    const allFieldsFilled = updatedData.amount !== "";

    // Add the status field to the data
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Set status to 1 if filled, otherwise 0
    // };

      const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

    try {
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function to avoid multiple API calls
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleInputChange = (field, value) => {
    const updatedData = { ...investmentAmountInputData, [field]: value };
    setInvestmentAmountInputData(updatedData);

    // Call the debounced save function
    debouncedSaveData(updatedData);
  };


  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard, investmentAmountInputData,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          investmentAmountInputData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      investmentAmountInputData,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    investmentAmountInputData,
  ]);
  return (
    <>
      <div className="row">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="Heart Icon" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            This year, I would like to invest{" "}
            <span className="clrgreen fw-semibold">
              ₹{" "}
              <input
                type="number"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${investmentAmountInputData.amount?.length + 3}ch`,
                  paddingLeft: "1rem",
                  minWidth: "5ch",
                }}
                value={investmentAmountInputData.amount}
                // onChange={(e) =>
                //   handleInputChange("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleInputChange("amount", value)
                  }
                }}
                placeholder="0"
                className="clrgreen fw-bold ps-3 moinput"
                aria-label="Investment Amount"
              />
            </span>{" "}
            in tax-saving instruments under section 80 (C).
          </p>
        </div>
      </div>
    </>
  );
};

// Debounce function to delay API calls
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

export default InvestmentAmountData;
